import { backbone } from '@visikon/backbone';
import { TreatmentDateContainer } from '@visikon/nativeui/src/program/TreatmentDate';
import { MediaFileUtils, useImagePreloader } from '@visikon/utils';
import * as React from 'react';
import styled from 'styled-components';
import { useWholeContent } from '../../common/selectors';
import { EditButton } from '../../components/edit/EditButton';
import { ContactButton } from '../contactPopup/ContactButton';
import { useSelfServiceUnsavedChanges } from '../embeddedMessageScript/EmbeddedMessageScript';
import { ProgramFeatures } from './ProgramFeatures';
import * as Styles from './ProgramMenu.styles';

const TitleWrapper = styled.div`
  gap: 18px;
  align-items: center;
  margin: inherit;
  display: flex;
  flex-direction: row;
  padding-top: 24px;
`;

export const ProgramMenu = () => {
  const country = backbone.store.getState().country;
  const content = useWholeContent();

  const logoUri = MediaFileUtils.getUriForImage(content.department?.logo?._id, country.languageCode);
  const [departmentLogo, setDepartmentLogo] = React.useState<React.ReactElement<any> | null>(null);

  const imgSrc = useImagePreloader(logoUri);

  const unsavedChanges = useSelfServiceUnsavedChanges();

  const unsavedData = unsavedChanges.operations
    ?.find((op) => op.contentType === 'module')
    ?.data?.translations?.find((t) => t.language === country.languageCode)?.data;

  React.useEffect(() => {
    if (imgSrc) {
      setDepartmentLogo(<img src={imgSrc} alt={'logo'} width={107} />);
    } else {
      setDepartmentLogo(<div style={{ width: 107, height: '100%' }} />);
    }
  }, [imgSrc]);

  return (
    <Styles.ProgramContainer>
      <Styles.Container>
        <Styles.Header>
          <Styles.Logo>
            <div style={{ width: '100%' }}>
              {departmentLogo}
              <Styles.SubTitle>{content.department.organization}</Styles.SubTitle>
            </div>
            <Styles.Spacer />
            <ContactButton />
          </Styles.Logo>
          <TitleWrapper>
            <Styles.Title>{unsavedData?.name ?? content.name}</Styles.Title>
            <EditButton id={'title-module'} contentType="module" />
          </TitleWrapper>
          <Styles.SubTitle>{unsavedData?.subName ?? content.subName}</Styles.SubTitle>

          <div style={{ marginTop: '8px' }}>
            <TreatmentDateContainer />
          </div>
        </Styles.Header>

        <ProgramFeatures />
      </Styles.Container>
    </Styles.ProgramContainer>
  );
};
